import styled from 'styled-components';

export const TableSelectWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const TableSelectStyled = styled.div<{
  $isOpen?: boolean;
  $disabled?: boolean;
  $withoutBg?: boolean;
}>`
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${(p) => p.theme.colors.secondaryDark};
  width: 100%;
  height: 100%;
  background: ${(p) =>
    p.$disabled
      ? p.theme.colors.white
      : p.$isOpen
      ? p.theme.colors.coloumnHover
      : p.$withoutBg
      ? p.theme.colors.white
      : p.theme.colors.coloumn};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  cursor: pointer;
  svg {
    min-width: 16px;
    transform: ${(p) => (p.$isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  }
  pointer-events: ${(p) => (p.$disabled ? 'none' : 'unset')};
`;

export const TableSelectOptions = styled.div<{ $openTop?: boolean }>`
  padding: 8px 0;
  position: absolute;
  max-height: 300px;
  overflow: auto;
  left: 0;
  top: ${(p) => (p.$openTop ? 'unset' : 'calc(100% - 16px)')};
  bottom: ${(p) => (p.$openTop ? 'calc(100% - 16px)' : 'unset')};
  width: 100%;
  border-radius: 9px;
  border: 1px solid ${(p) => p.theme.colors.stroke};
  background: ${(p) => p.theme.colors.white};
  box-shadow:
    4px 5px 9px 0px rgba(63, 81, 126, 0.08),
    -3px -3px 9px 0px rgba(63, 81, 126, 0.06);
  z-index: 1;
`;

export const OptionsItem = styled.div`
  padding: 10px;
  color: ${(p) => p.theme.colors.black};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  background: ${(p) => p.theme.colors.white};
  &:hover {
    color: ${(p) => p.theme.colors.white};
    background: ${(p) => p.theme.colors.primary};
  }
  cursor: pointer;
`;
